import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import i18n from 'i18n';

// Embed content from https://github.com/uxsolutions/bootstrap-datepicker/blob/master/js/locales/bootstrap-datepicker.de.js
$.fn.datepicker.dates.de = {
  days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  daysShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
  daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  today: 'Heute',
  monthsTitle: 'Monate',
  clear: 'Löschen',
  weekStart: 1,
  format: 'dd.mm.yyyy',
};

$.fn.datepicker.dates.fr = {
  days: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  daysShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  daysMin: ['d', 'l', 'ma', 'me', 'j', 'v', 's'],
  months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
  monthsShort: ['janv.', 'févr.', 'mars', 'avril', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  today: "Aujourd'hui",
  monthsTitle: 'Mois',
  clear: 'Effacer',
  weekStart: 1,
  format: 'dd/mm/yyyy',
};

$.fn.datepicker.dates.it = {
  days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  daysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  daysMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
  months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  monthsShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
  today: 'Oggi',
  monthsTitle: 'Mesi',
  clear: 'Cancella',
  weekStart: 1,
  format: 'dd/mm/yyyy',
};

// Embed content from https://github.com/uxsolutions/bootstrap-datepicker/blob/master/js/locales/bootstrap-datepicker.pt-BR.js
$.fn.datepicker.dates['pt-BR'] = {
  days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  daysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
  months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  today: 'Hoje',
  monthsTitle: 'Meses',
  clear: 'Limpar',
  weekStart: 1,
  format: 'dd/mm/yyyy',
};
// The runtime locale reaches us as either 'pt-BR' or just 'pt', so register the
// Brazilian dictionary under the base subtag too (the app has no European pt).
$.fn.datepicker.dates.pt = $.fn.datepicker.dates['pt-BR'];

// Application setup
// Fall back to English only when neither the full locale nor its base subtag has
// a dictionary, otherwise the library crashes in fillDow. This keeps regioned
// locales working (de-CH -> de, en-001 -> en, pt-BR/pt -> pt).
const baseLocale = i18n.locale.split('-')[0];
const hasDictionary = $.fn.datepicker.dates[i18n.locale] || $.fn.datepicker.dates[baseLocale];
$.fn.datepicker.defaults.language = hasDictionary ? i18n.locale : 'en';
$.fn.datepicker.dates.de.format = 'dd/mm/yyyy';
$.fn.datepicker.dates.en.format = 'dd/mm/yyyy';
$.fn.datepicker.defaults.weekStart = 1;
$.fn.datepicker.defaults.todayHighlight = true;
$.fn.datepicker.defaults.zIndexOffset = 200;
